






































import { LayoutStore, ShapeStore } from "@/mixins/store";
import { ProductLineName } from "@/models/products/collection";
import { mixins } from "vue-class-component";
import { Component } from "vue-property-decorator";

@Component
export default class CameraControls extends mixins(LayoutStore, ShapeStore) {
  protected closeOnClick = true;
  protected ProductLineName = ProductLineName;

  protected async changeCamera(camPosition: 0 | 1 | 2 | 3 | 4): Promise<void> {
    await this.$viewer.GoToCamera(camPosition);
  }

  get isRectangle(): boolean {
    return this.umbrellaModel &&
      (this.umbrellaModel.model.indexOf("-R") > -1 ||
        (this.umbrellaModel.shape &&
          this.umbrellaModel.shape[0].toLowerCase() === "rectangle"))
      ? true
      : false;
  }

  get label(): string {
    let label = "";
    if (
      this.collection.handle === ProductLineName.MontereyPulleyLift ||
      this.collection.handle === ProductLineName.MontereyAutoTilt ||
      this.collection.handle === ProductLineName.MontereyCrank ||
      this.collection.handle === ProductLineName.Greenwich
    ) {
      label = "monterey";
    } else {
      label = this.collection.handle.replaceAll("_", "-");
    }
    if (this.isRectangle) {
      label = label + "-rectangle";
    }
    return label;
  }

  get frontAngle(): string {
    return require(`../../../assets/images/cam/${this.label}-front-angle.png`); // "require" is needed because of webpack issue with compiling dynamic image urls
  }

  get topAngle(): string {
    return require(`../../../assets/images/cam/${this.label}-top-angle.png`); // "require" is needed because of webpack issue with compiling dynamic image urls
  }

  get highAngle(): string {
    return require(`../../../assets/images/cam/${this.label}-high-angle.png`); // "require" is needed because of webpack issue with compiling dynamic image urls
  }

  get sideAngle(): string {
    return require(`../../../assets/images/cam/${this.label}-side-angle.png`); // "require" is needed because of webpack issue with compiling dynamic image urls
  }
}
